export default __webpack_public_path__ + "static/media/number1.c1b63e7b.png";